import React, {FC, useEffect, useState} from 'react';
import {ArcElement, Chart as ChartJS, Legend, Tooltip} from 'chart.js';
import {Pie} from 'react-chartjs-2';
import {Skeleton, Text} from "@mantine/core";
import {fetchLeadOriginStatistic} from "../../Service/restapi/statisticService";
import PanePaper from "../../Molecules/PanePaper";


ChartJS.register(ArcElement, Tooltip, Legend);

interface StatisticData {
  labels: string[],
  datasets: StatisticDataset[]
}

interface StatisticDataset {
  label: string,
  data: number[],
  backgroundColor: string[],
  borderColor: string[],
  borderWidth: number
}

export const options = {
  plugins: {
    legend: {
      display: true,
      position: 'right' as const,
    },
  },
  responsive: true,
};

interface Props {
  year: string | null,
  eventKind: string | null,
  hasProperLicence: boolean
}

const LeadOriginStatistic: FC<Props> = ({year, eventKind, hasProperLicence}) => {

  const [statisticData, setStatisticData] = useState<StatisticData>();

  useEffect(() => {
    if (hasProperLicence) {
      setStatisticData(undefined);
      const abortController = new AbortController();

      fetchLeadOriginStatistic(year, eventKind, abortController.signal)
        .then((resp) => {
          if (resp.ok) {
            resp.json().then(setStatisticData);
          } else {
            console.error(`could not load lead origin statistics`);
          }
        })
        .catch((error) => {
          console.error({ error });
          console.error(`could not load lead origin statistics`);
        });
      return () => {
        abortController.abort();
      };
    }

  }, [year, eventKind, hasProperLicence]);

  return (

      <PanePaper
        title="Aufmerksam geworden durch"
      >
        <Text italic color="dimmed" size="xs" weight="lighter">
          Hinweis: Die Farben werden bei diesem Diagram zufällig generiert.
        </Text>
        {(!statisticData && hasProperLicence) && <Skeleton radius="sm" height={35} width="100%" />}
        {statisticData && <Pie data={statisticData} options={options} />}

      </PanePaper>
  );

}

export default LeadOriginStatistic;
